"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
var Semaphore_1 = require("./Semaphore");
exports["default"] = Semaphore_1["default"];
__export(require("./Lock"));
